import React, { useEffect, useState } from 'react'
import Header from '../../common/Header'
import Footer from '../../common/Footer'
import ListingDetailSection from './components/ListingDetailSection'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import axiosInstance from '../../axiosInstance'

const ListingDetail = () => {
  const navigate = useNavigate()
  const [data,setData] = useState({})
  const [loading,setLoading] = useState(false)
  const [error,setError] = useState("")
  const getDetails = async(token,id) => {
    try {
      setLoading(true)
      setError("")
      const response = await axiosInstance.get(`/api/inventory/${id}`,{
        headers:{
          "Authorization":token
        }
      })
      setData(response?.data?.data);
    } catch (error) {
       if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally{
      setLoading(false)
    }
  }
  useEffect(()=>{
    const listing = JSON.parse(localStorage.getItem("Listing-Detail"))
    if(!listing || !listing.id) return navigate("/Listing")
    const auth = JSON.parse(localStorage.getItem("auth"))
    if(!auth || !auth.token) return navigate("/")
    getDetails(auth.token,listing.id)
  },[navigate])
  const handleClose = () => {
    localStorage.removeItem("Listing-Detail")
    navigate("/Listing")
  }
  return (
    <div className='boxcar-wrapper' style={{backgroundColor:"#050B20"}} >
      <div style={{paddingBottom:"220px"}} >
      <Header preclass="normal"  />
      </div>
      <div style={{zIndex:9999}} >
      <ListingDetailSection handleClose={handleClose} data={data} loading={loading} error={error}/>
    </div>
    </div>
  )
}

export default ListingDetail
